module.exports = __webpack_public_path__ + "static/media/cq_sinistri_collegati_pratica.833a3348.svg";